'use client';
import '../_helpers/auth-header';
import { CacheProvider } from '@emotion/react';
import { useCallback, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import createEmotionCache from '../theme/createEmotionCache';
import { LoadingProgressProvider } from '@/hooks/useLoadingProgress';
import DeviceManager from '../components/util/deviceManager';
import { CookieAcceptanceProvider } from '@/hooks/useCookies';
import preventZoomInOnMobiles from '@/utils/preventZoomInOnMobiles';
import dynamic from 'next/dynamic';


// Import ThemeConfig with no SSR
const ThemeConfig = dynamic(() => import('../theme'), {
  ssr: false,
});

// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache();

export function ClientProviders({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = useState<any>({});

  const updateTheme = useCallback(() => {
    setTheme({
      device: {
        mobile: DeviceManager.isMobile(),
        landscape: DeviceManager.isHorizontalMobileView(),
        ios: DeviceManager.isIOS(),
        tablet: DeviceManager.isTablet(),
      },
    });
  }, []);

  useEffect(() => {
    preventZoomInOnMobiles(window);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', updateTheme);

    updateTheme();

    return () => {
      window.removeEventListener('resize', updateTheme);
    };
  }, [updateTheme]);

  return (
    <CacheProvider value={clientSideEmotionCache}>
      {/* MUI Theme */}
      <ThemeConfig>
        {/* styled-components theme */}
        <ThemeProvider theme={theme}>
          <LoadingProgressProvider>
            <CookieAcceptanceProvider>
              {children}
            </CookieAcceptanceProvider>
          </LoadingProgressProvider>
        </ThemeProvider>
      </ThemeConfig>
    </CacheProvider>
  );
}
